import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Newsletter from './components/Newsletter';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import OurStory from './pages/OurStory';
import WhatWeBelieve from './pages/WhatWeBelieve';
import Gallery from './pages/Gallery';
import BookUs from './pages/BookUs';

function AppRoutes() {
  const location = useLocation();
  const onHome = location.pathname === '/';
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/our-story" element={<OurStory />} />
        <Route path="/what-we-believe" element={<WhatWeBelieve />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/book-us" element={<BookUs />} />
      </Routes>
      {/* Keep Newsletter mounted at app level; only visible on Home */}
      <div style={{ display: onHome ? 'block' : 'none' }}>
        <Newsletter />
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
